import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const ApidocsRoute: Route = {
  path: 'apidocs',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/apidocs.component').then((m) => m.ApidocsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
